import DataAccess from './constants';
import API from './API';
const path = '/api/ValidateRecaptcha/ValidateRecaptchaToken'

export const apiValidateRecaptcha = (postdata) => {

    let api = new API(DataAccess.middlewareUrl, DataAccess.userName, DataAccess.password, DataAccess.middlewareUserName, DataAccess.middlewarePassword, true);
    return api.getData(path + "?recaptchav3token=" + postdata.recaptchaToken + "&sessionID=" + postdata.sessionID);

}